import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setExternalAccess } from '../utils/externalAccess';

export default function ExternalAuthPage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token')?.trim();
    const companyId = params.get('company_id')?.trim() || location.search
      .match(/[?&]company_id\+([^&]*)/i)?.[1]
      ?.trim();

    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    setExternalAccess(token, companyId);
    params.delete('token');
    params.delete('company_id');
    if (companyId) params.delete(`company_id ${companyId}`);

    // From a company page in the CRM, land on that company's custom apps instead of the general dashboard.
    if (companyId) {
      navigate({ pathname: '/custom-apps', search: `?crm_company_id=${encodeURIComponent(companyId)}` }, { replace: true });
      return;
    }
    const remainingQuery = params.toString();
    navigate({
      pathname: '/dashboard',
      search: remainingQuery ? `?${remainingQuery}` : '',
    }, { replace: true });
  }, [location.search, navigate]);

  return (
    <main className="splash" aria-live="polite">
      Preparing dashboard...
    </main>
  );
}
